// @flow
// ----------------------------------------------------------------------
// <copyright file="ContextMenu.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable no-undefined */

/**
 * ContextMenu component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CollapsibleList from 'share/components/controls/Izenda.CollapsibleList';
import List from 'share/components/controls/Izenda.List';
import classnames from 'classnames';
import BrowserUtils from 'share/utils/Izenda.BrowserUtils';
import LayoutUtils from 'share/utils/Izenda.LayoutUtils';
import connect from 'share/enhancers/Izenda.Connect';
import MenuItem from './Izenda.MenuItem';
import { map, includes } from 'lodash/fp';

@connect()
class ContextMenu extends Component {
  static propTypes = {
    enabled: PropTypes.bool,
    activeKey: PropTypes.string,
    onSelected: PropTypes.func,
    className: PropTypes.string
  };

  render() {
    const classes = classnames(this.props.className, 'panel-group collapsible-list-items context-menu');
    return <CollapsibleList className={classes}>{map(this.renderTopItem)(this.props.dataSource)}</CollapsibleList>;
  }

  renderTopItem = (topItem: any) => {
    if (!this.props.enabled) {
      return (
        <CollapsibleList.Item className='panel disabled-pointer-event' key={topItem.key}>
          <CollapsibleList.ItemHeader className='panel-heading'>
            {this.renderItemHeader(topItem)}
          </CollapsibleList.ItemHeader>
        </CollapsibleList.Item>
      );
    }
    return (
      <CollapsibleList.Item
        className='panel'
        key={topItem.key}
        itemExpanded={includes(this.props.activeKey, map('key', topItem.items))}
      >
        <CollapsibleList.ItemHeader className='panel-heading'>
          {this.renderItemHeader(topItem)}
        </CollapsibleList.ItemHeader>
        <CollapsibleList.ItemBody className='panel-body'>
          {this.renderSubItems(topItem.items, topItem.key)}
        </CollapsibleList.ItemBody>
      </CollapsibleList.Item>
    );
  }

  renderItemHeader = (topItem: any) => {
    const handleClick = !topItem.items ? this.handleClick : undefined;
    return this.renderMenuItem(handleClick)(topItem);
  }

  renderSubItems = (childItems: any, key: string) => {
    return (
      <List className='list-group' key={key}>
        {map(this.renderMenuItem(this.handleClick))(childItems)}
      </List>
    );
  }
  renderMenuItem = (handleClick: any) => {
    const { enabled, activeKey, renderChangedIcon } = this.props;
    return item => (
      <MenuItem
        item={item}
        key={item.key}
        enabled={enabled}
        activeKey={activeKey}
        handleClick={handleClick}
        renderChangedIcon={renderChangedIcon}
      />
    );
  };
  handleClick = (e: any) => {
    const dataName = $izenda(e.currentTarget).data('name');

    const { activeKey, enabled } = this.props;

    if (BrowserUtils.isMobileDevice()) {
      if (dataName === activeKey) {
        LayoutUtils.toggleMiddelPanel(true);
      }

      if (enabled && dataName !== activeKey) {
        LayoutUtils.toggleSideBar(false);
        LayoutUtils.toggleIconMenu(false);
      }
    }

    if (!enabled) {
      return;
    }
    const onSelected = this.props.onSelected;
    onSelected && onSelected(dataName, activeKey);
  }
}

export default ContextMenu;



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.ContextMenu.js